/*售后相关
i:get || post
h:requestGet ||requestPost
*/
import axios from "../axios";
export default {
  //退款申请页详情
  applyDetail: (data) => {
    return axios.get("/products/course/after_sale/apply/detail", data);
  },
  //退款申请
  applySubmit: (data) => {
    return axios.post("/products/course/after_sale/apply/submit", data);
  },
  // 售后申请状态页
  afterSaledetail: (data) => {
    return axios.get("/products/course/after_sale/detail", data);
  },
  // 撤销退款申请
  afterSaleCancel: (data) => {
    return axios.post("/products/course/after_sale/cancel", data);
  },
};
